import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Typography, Modal, Button, Icon } from "@plum-xoxo/admin-dsm";
import { app_path } from "config";

class KybErrorModal extends Component {
  state = {
    showModal: true,
  };

  handleModal = (fromHeader = false) => {
    this.setState({
      showModal: false,
    });
    this.props.closeModal ? this.props.closeModal(fromHeader) : null;
    if (this.props.reward_module == "Xoxo Link") {
      this.props.actionHandler();
    }
  };

  renderContent = () => {
    const { reward_module, kyb_status } = this.props;
    let content = "";
    let submit_kyb = (
      <Link
        to={`/${app_path}/accounts/platform-preferences`}
        style={{ textDecoration: "underline" }}
      >
        {kyb_status === 3 || kyb_status === 5
          ? "resubmit your verification details"
          : "submit your verification details"}
      </Link>
    );
    let subContent =
      kyb_status === 3 || kyb_status === 5 ? (
        <>Please {submit_kyb} to get your account approved</>
      ) : (
        `Submit your verification details to get your account approved `
      );
    let kybVerificationText = (
      <>
        We are currently reviewing your details and verify your account in 1-2
        business days
        {reward_module === "code campaign" ||
        reward_module === "link campaign" ||
        reward_module == "Add Admin"
          ? " afterwards you can"
          : null}
      </>
    );
    let KybResubmissionText = (
      <>
        <Typography color="dark" shade="c200" className="mb-0 mt-8">
          Your account verification requires resubmission.
          <Typography color="dark" shade="c300" className="mb-0 mt-12">
            Resubmit your verification details to get approved and{" "}
          </Typography>
        </Typography>
      </>
    );
    let NonKybLimit = (
      <>
        You have reached the limit for new{" "}
        {reward_module === "code campaign" || reward_module === "link campaign"
          ? "campaign creation"
          : `${reward_module}  generation`}{" "}
        for non-verified accounts.{" "}
      </>
    );
    let module = "";
    if (reward_module == "code campaign" || reward_module == "link campaign") {
      module = "create new campaign";
      content = (
        <>
          <Typography.H2 color="dark" shade="c300" className="mb-12">
            Can not {module}!
          </Typography.H2>{" "}
          <p className="inkNormal">
            {NonKybLimit}{" "}
            {kyb_status === 0 ? (
              <Typography color="dark" shade="c200" className="mt-16">
                {subContent} and {module}.
              </Typography>
            ) : kyb_status === 1 ? (
              <Typography color="dark" shade="c200" className="mt-16">
                {kybVerificationText} {module}.
              </Typography>
            ) : kyb_status === 3 || kyb_status === 5 ? (
              <Typography color="dark" shade="c200" className="mt-16">
                {KybResubmissionText} {module}.
              </Typography>
            ) : null}
          </p>
        </>
      );
      return content;
    } else if (reward_module == "Add Admin") {
      module = "add new admins";
      content = (
        <>
          <Typography.H2 color="dark" shade="c300" className="mb-12">
            Can not {module}
          </Typography.H2>
          <p>
            {kyb_status === 0 ? (
              <Typography color="dark" shade="c200">
                {subContent} and {module} .
              </Typography>
            ) : kyb_status === 1 ? (
              <Typography color="dark" shade="c200">
                {kybVerificationText} {module}
              </Typography>
            ) : kyb_status === 3 || kyb_status === 5 ? (
              <Typography color="dark" shade="c200">
                {KybResubmissionText} {module}
              </Typography>
            ) : null}
          </p>
        </>
      );
      return content;
    } else {
      module = "generate more rewards";
      let rewardGenerationLimit = (
        <>You have reached the limit for new {reward_module} generation</>
      );
      content = (
        <>
          <div className="d-flex justify-content-between">
            <Typography.H2 color="dark" shade="c300" className="mb-12">
              Cannot send more rewards!
            </Typography.H2>
            <Icon
              iconName="Close"
              onClick={() => {
                this.handleModal();
              }}
              size="m"
            />
          </div>

          <p>
            {kyb_status === 0 ? (
              <Typography color="dark" shade="c200" className="mb-16">
                {NonKybLimit}
                <div className="mt-8">
                  {subContent} and {module}.
                </div>
              </Typography>
            ) : kyb_status === 1 ? (
              <Typography color="dark" shade="c200">
                {rewardGenerationLimit}.
                <div className="mt-8">{kybVerificationText}.</div>
              </Typography>
            ) : kyb_status === 3 || kyb_status === 5 ? (
              <Typography color="dark" shade="c200">
                {rewardGenerationLimit}. {KybResubmissionText} {module}.
              </Typography>
            ) : null}
          </p>
        </>
      );
      return content;
    }
  };

  render() {
    const { showModal } = this.state;
    const { kyb_status } = this.props;
    return (
      <div>
        <Modal
          isOpen={showModal}
          onClose={() => {
            this.handleModal();
          }}
          size="sm"
        >
          <Typography>{this.renderContent()}</Typography>
          <div
            style={{
              textAlign: "right",
            }}
            className="mt-16"
          >
            {kyb_status === 1 ? (
              <Button
                color="primary"
                variant="outlined"
                mr="1"
                onClick={() => {
                  this.handleModal();
                }}
              >
                Ok, Got it
              </Button>
            ) : (
              <>
                <Button
                  color="primary"
                  variant="plain"
                  mr="1"
                  onClick={() => {
                    this.handleModal();
                  }}
                >
                  Cancel
                </Button>
                <Link to={`/${app_path}/accounts/platform-preferences`}>
                  <Button
                    color="primary"
                    variant="fill"
                    onClick={() => window.location.reload()}
                  >
                    Verify Account
                  </Button>
                </Link>
              </>
            )}
          </div>
        </Modal>
        {/* <Modal isOpen={showModal} className="message-modal">
          <div className="text-right m-3">
            <img
              style={{
                cursor: "pointer",
                width: "16px",
                height: "16px",
                color: "#5F738C",
              }}
              src="/admin/img/svg-icons/cross.svg"
              onClick={() => {
                this.handleModal(true);
              }}
            />
          </div>
          <ModalBody>
            <Row>
              <Col className="mb-3">
                <img src="/admin/img/icons/error-icon.svg" />
              </Col>
            </Row>
            {this.renderContent()}
          </ModalBody>
          <ModalFooter className="m-0 w-100" style={{ justifyContent: "end" }}>
            <Button
              color="primary"
              onClick={() => {
                this.handleModal();
              }}
            >
              Ok
            </Button>
          </ModalFooter>
        </Modal> */}
      </div>
    );
  }
}

export default KybErrorModal;
